export default __webpack_public_path__ + "static/media/bedWhiteV2.c863c24f.svg";